export const FEAT_CHOICE_SET_REQUEST = 'character.FEAT_CHOICE_SET_REQUEST';
export const FEATS_SET = 'character.FEATS_SET';
export const FEATS_SET_COMMIT = 'character.FEATS_SET_COMMIT';
export const ADHOC_FEAT_CREATE = 'character.ADHOC_FEAT_CREATE';
export const ADHOC_FEAT_REMOVE = 'character.ADHOC_FEAT_REMOVE';
export const SET_ENTITY_FEAT = 'character.SET_ENTITY_FEAT';
